<template>
  <LayoutMain @toTop="scrollToTop">
    <vueScroll v-show="matList.length" ref="vs" @handle-scroll="handleScroll">
      <div class="home_list" :class="{ 'is_element': isElement }">
        <component
          :is="itemComps" v-for="item in matList" :key="item.id" :item="item"
          :class="`home_${ isElement ? 'three' : 'two' }_item`">
          <template v-slot:center>
            <div v-report:mainclick="{ area: 'content', pos: 0 }" class="home_item_down" @click="clickDownload(item)" />
          </template>
        </component>
      </div>

      <!-- 翻页，置顶功能 -->
      <TurnPage
        class="home_turn_page" :toTopVisible="true" :hasBefore="false" :hasNext="false"
        @toTop="toTopHandle" />
    </vueScroll>
    <div v-show="!matList.length" class="no_data">
      <p class="font">没有找到相关内容，换个词试试</p>
    </div>
  </LayoutMain>
</template>

<script>
import LayoutMain from '@/components/Layout/LayoutMain.vue'
import TwoColItem from '@/components/ItemLayout/TwoColItem.vue'
import ThreeColItem from '@/components/ItemLayout/ThreeColItem.vue'
import TurnPage from '@/components/TurnPage/index.vue'

import { RetCode, limitCode, limitCodeByPay } from '@/api/bussinessCode.js'
import { scrollRateFast } from '@/common/const.js'
import { CacheGetSource, CacheIsNewUser } from '@/common/cache.js'
import { parseURL } from '@/common/utils.js'
import {
  ClientGetUserInfo, ClientDownload, ClientOpenTabsByBuy, ClientGetIsVip,
  ClientOpenResource, ClientOpenTabsByLogin, ClientShow
} from '@/api/clientApi.js'
import api from '@/api'
import { report } from '@/report/index.js'

export default {
  name: 'Home',

  components: { LayoutMain, TwoColItem, ThreeColItem, TurnPage },

  computed: {
    isElement () {
      return this.$store.state.activeIndex === this.$store.state.elementIndex
    },

    itemComps () {
      return this.isElement ? 'ThreeColItem' : 'TwoColItem'
    },

    matList () {
      return this.$store.state.home.homeRes.list
    },

    count () {
      return this.$store.state.home.homeRes.count
    },

    pageSize () {
      return this.$store.state.home.home.size
    },

    page () {
      return this.$store.state.home.home.page
    },

    activeIndex () {
      return this.$store.state.activeIndex
    },

    hasNext () {
      return this.$store.state.home.hasNext
    },

    isLoginedIn () {
      return this.$store.getters.isLoginedIn
    }
  },

  created () {
    this.getMatList()
    this.reportOpen()

    // 子页面关闭，通知父页面，不建议扔app.vue，父子页面都会触发
    window.sendSubTabCloseMsg = () => {
      ClientGetUserInfo((userInfo) => {
        this.$store.commit('vuexSetUserInfo', userInfo)
      }, () => {
        this.$toast({ desc: '获取用户信息失败，请联系客服！' })
      })
    }

    // 下载是异步线程，所以成功给回调
    window.sendDownloadMsg = (res1) => {
      this.$store.commit('vuexChangeLoading', false)
      this.$store.commit('vuexChangeDownloadStatus', false) // 取消下载也会触发下载失败

      const res = JSON.parse(res1) // 没有经历封装，所以得parse以下

      if (res.cancel) { return } // 取消下载

      if (!res.downloadok) {
        report('download', { goodsid: res.id, goodstype: '', free: '', classid: '', ext: '4' })

        this.$toast({ desc: `下载失败，请联系重试或者联系客服，素材id：${res.id}` })
      }
    }
  },

  mounted () {
    ClientShow() // 客户端一开始会加载，渲染完了手动触发窗口打开
  },

  methods: {
    reportOpen () {
      ClientGetIsVip((res) => {
        const dubaVip = res?.result || false

        report('open', { ptype: 1, isnew: CacheIsNewUser() ? '1' : '2', isdbvip: dubaVip ? '1' : '2' })
      })
    },

    getMatList () {
      this.$store.dispatch('home/vuexGetMatList')
    },

    scrollToTop () {
      this.$refs.vs.scrollTo({ y: 0 }, scrollRateFast * this.page)
    },

    toTopHandle () {
      report('mainclick', { area: 'turn', pos: 0 })

      this.scrollToTop()
    },

    next () { this.targetPage(this.page + 1) },

    targetPage (page) {
      this.$store.dispatch('home/vuexChangeHomeParames', { page })
    },

    handleScroll (v) { // 记录滚动的位置, handle-scroll-complete不生效，到时候可以优化
      if (this._timer) { clearTimeout(this._timer) } // 防止滚动事件调用多次接口

      const hasNext = this.count > this.page * this.pageSize
      if (!hasNext) { return }

      this._timer = setTimeout(() => {
        clearTimeout(this._timer)
        if (v.process > 0.95) {
          this.next()
        }
      }, 200)
    },

    cutSuffix (url) {
      const lastUrl = parseURL(url).file
      return lastUrl.slice(lastUrl.indexOf('.'))
    },

    clickDownload (item) {
      report('download', { goodsid: item.id, goodstype: '', free: '', classid: item.class_id })

      ClientOpenResource(item.id + '').catch(() => {
        if (!this.isLoginedIn) {
          ClientOpenTabsByLogin()
          return
        }

        this.apixDownLoad(item)
      })
    },

    apixDownLoad (item) {
      api.material.download({ data: { mat_id: item.id, source: CacheGetSource() } }).then(res => {
        const url = res?.data?.url
        if (url) {
          const params = { id: item.id + '', fileName: item.name + this.cutSuffix(url), type: this.activeIndex, url }

          ClientDownload(params)
            .then(res => {
              if (!res.result) {
                this.$toast({ desc: '客户端下载调用失败，请重试或联系客服' })
                return
              }
              this.$store.commit('vuexChangeLoading', true)
              this.$store.commit('vuexChangeDownloadStatus', true)
            })
            .catch(() => {
              report('download', { goodsid: item.id, goodstype: '', free: '', classid: item.class_id, ext: '4' })

              this.$toast({ desc: '下载失败，请重试或联系客服！' })
              this.$store.commit('vuexChangeLoading', false)
            })
          return
        }
        this.$toast({ desc: '获取链接失败，请联系客服' })
      }).catch(data => {
        const code = String(data?.ret || '')

        if (code === limitCodeByPay) {
          report('download', { goodsid: item.id, goodstype: '', free: '', classid: item.class_id, ext: '1' })

          this.$toast({ desc: '该模板是付费模板' })
          ClientOpenTabsByBuy()
          return
        }

        if (code === limitCode) {
          report('download', { goodsid: item.id, goodstype: '', free: '', classid: item.class_id, ext: '2' })

          this.$store.commit('tipsDialog/vuexChangeUpdateVipLevelDialog', true)
          return
        }

        if (RetCode?.[code]) {
          report('download', { goodsid: item.id, goodstype: '', free: '', classid: item.class_id, ext: '3' })

          this.$toast({ desc: RetCode[data.ret] })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.home_list {
  width: 505px;
  padding: 8px 6px;

  &.is_element { padding: 8px 16px; }

  .home_two_item { margin: 8px 10px; }
  .home_three_item { margin: 20px 22px; }

  .home_item_down {
    width: 32px;
    height: 34px;
    cursor: pointer;
    background-image: url(~@/assets/images/icon_down.svg);
    background-size: cover;

    &:hover { background-image: url(~@/assets/images/icon_down_hover.svg); }
  }
}

.home_turn_page { position: fixed; bottom: 40px; left: 450px; z-index: 10; }

.no_data  {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 256px;
  height: 211px;
  text-align: center;
  background: url(~@/assets/images/bg_no_data.png) center center no-repeat;
  background-size: 100% 100%;
  transform: translate(-50%, -50%);

  .font { margin-top: 135px; font-size: 16px; color: #AFB0C0; }
}
</style>
